export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6499.0fdb0571.jpg";